import { render, staticRenderFns } from "./ProduceChart.vue?vue&type=template&id=3dcd7078&"
import script from "./ProduceChart.vue?vue&type=script&lang=js&"
export * from "./ProduceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports